namespace RioERP.Enquiry {
    export interface PendingOrderProductsRow {
        Id?: number;
        PendingOrderId?: number;
        ProductId?: number;
        Name?: string;
        Sku?: string;
        IsActive?: boolean;
        PendingOrderNopOrderId?: number;
        PendingOrderCustomerName?: string;
        PendingOrderMobile?: string;
        PendingOrderEmail?: string;
        PendingOrderAddress?: string;
        PendingOrderCity?: string;
        PendingOrderStateId?: number;
        PendingOrderPincode?: number;
        PendingOrderIsActive?: boolean;
        PendingOrderInsertUserId?: number;
        PendingOrderInsertDate?: string;
        PendingOrderUpdateUserId?: number;
        PendingOrderUpdateDate?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace PendingOrderProductsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Enquiry.PendingOrderProducts';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            PendingOrderId = "PendingOrderId",
            ProductId = "ProductId",
            Name = "Name",
            Sku = "Sku",
            IsActive = "IsActive",
            PendingOrderNopOrderId = "PendingOrderNopOrderId",
            PendingOrderCustomerName = "PendingOrderCustomerName",
            PendingOrderMobile = "PendingOrderMobile",
            PendingOrderEmail = "PendingOrderEmail",
            PendingOrderAddress = "PendingOrderAddress",
            PendingOrderCity = "PendingOrderCity",
            PendingOrderStateId = "PendingOrderStateId",
            PendingOrderPincode = "PendingOrderPincode",
            PendingOrderIsActive = "PendingOrderIsActive",
            PendingOrderInsertUserId = "PendingOrderInsertUserId",
            PendingOrderInsertDate = "PendingOrderInsertDate",
            PendingOrderUpdateUserId = "PendingOrderUpdateUserId",
            PendingOrderUpdateDate = "PendingOrderUpdateDate",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
